var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("authentication-service-provider", {
        ref: "authenticationServiceProvider",
        on: {
          "login-success": _vm.onLoginSuccess,
          "login-social-success": _vm.onLoginSuccess,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({
              login,
              loginSocial,
              goToSignUp,
              loaders,
              forms,
              errorMessage,
            }) {
              return [
                _c(
                  "div",
                  { staticClass: "wrapper" },
                  [
                    _c("locale-changer", { staticClass: "pb-3" }),
                    _c(
                      "div",
                      { staticClass: "form-wrapper" },
                      [
                        _c("h1", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("auth.logInPayment.title")) +
                              " "
                          ),
                        ]),
                        _c(
                          "v-alert",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: errorMessage,
                                expression: "errorMessage",
                              },
                            ],
                            attrs: {
                              border: "left",
                              color: "red",
                              type: "error",
                            },
                          },
                          [_vm._v(" " + _vm._s(errorMessage) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "button-google",
                            attrs: {
                              block: "",
                              "x-large": "",
                              elevation: "0",
                              outlined: "",
                              disabled: loaders.socialLogin || loaders.login,
                              loading: loaders.socialLogin,
                              color: "secondary",
                            },
                            on: {
                              click: function ($event) {
                                return loginSocial("google")
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "mr-2",
                              attrs: {
                                src: require("@/assets/img/logos/google.png"),
                                alt: "google",
                              },
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("auth.logInPayment.logInWithGoogle")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c("p", { staticClass: "line-through" }, [
                          _vm._v(" " + _vm._s(_vm.$t("auth.global.or")) + " "),
                        ]),
                        _c("validation-observer", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ invalid }) {
                                  return [
                                    _c(
                                      "v-form",
                                      {
                                        nativeOn: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return login()
                                          },
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "email",
                                            rules: "required|email",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          _vm.$t(
                                                            "auth.global.email"
                                                          ),
                                                        outlined: "",
                                                        required: "",
                                                        disabled:
                                                          loaders.login ||
                                                          loaders.socialLogin,
                                                        "background-color":
                                                          "white",
                                                        "error-messages":
                                                          errors,
                                                        placeholder: _vm.$t(
                                                          "auth.global.enterEmail"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          forms.login.email,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            forms.login,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "forms.login.email",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "password",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "auth.global.password"
                                                        ),
                                                        outlined: "",
                                                        required: "",
                                                        disabled:
                                                          loaders.login ||
                                                          loaders.socialLogin,
                                                        "background-color":
                                                          "white",
                                                        type: _vm.showPassword
                                                          ? "text"
                                                          : "password",
                                                        placeholder: _vm.$t(
                                                          "auth.global.enterPassword"
                                                        ),
                                                        "error-messages":
                                                          errors,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "append",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.showPassword =
                                                                            !_vm.showPassword
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.showPassword
                                                                                ? _vm
                                                                                    .icons
                                                                                    .mdiEye
                                                                                : _vm
                                                                                    .icons
                                                                                    .mdiEyeOff
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          forms.login.password,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            forms.login,
                                                            "password",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "forms.login.password",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              block: "",
                                              "x-large": "",
                                              type: "submit",
                                              color: "primary",
                                              elevation: "0",
                                              disabled:
                                                loaders.login ||
                                                loaders.socialLogin ||
                                                invalid,
                                              loading: loaders.login,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return login()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-outfit-semi-bold button-continue",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("continue"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("auth.global.byContinuing")) + " "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://ideabuddy.com/terms-of-service/",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("auth.global.termsAndConditions"))
                              ),
                            ]
                          ),
                          _vm._v(" " + _vm._s(_vm.$t("auth.global.and")) + " "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://ideabuddy.com/privacy-policy/",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("auth.global.privacyPolicy"))
                              ),
                            ]
                          ),
                          _vm._v(". "),
                        ]),
                        _c("p", { staticClass: "already-have" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("auth.logInPayment.dontHave"))
                            ),
                          ]),
                          _vm._v("   "),
                          _c("a", { on: { click: goToSignUp } }, [
                            _vm._v(_vm._s(_vm.$t("auth.logInPayment.signUp"))),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }